import React, { useState } from 'react';
import './style/ReportSend.css'; // Assuming this path is correct
import TopNavbar from './TopNavbar';
import AboutApp from '../AllData/AboutApp';
import Latex from 'react-latex';
import AllQuestions from '../AllData/AllQuestions';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { API_CONFIG } from './../../config';

const USERDOUBTSEND = `${API_CONFIG.BASE_URL}${API_CONFIG.ENDPOINTS.USERDOUBTSEND}`;


const ReportSend = () => {

    const { id } = useParams();

    const questions = AllQuestions;

    const phoneFromStorage = localStorage.getItem('userPhone');

    const questionData = questions.find(
        submission => submission._id.$oid === id
    );

    const isData = !!questionData;
    const question = isData ? questionData.question : null;
    const question_img = isData ? questionData.question_img : null;
    const ans = isData ? questionData.answer : null;
    const type = isData ? questionData.type : null;
    const subject = isData ? questionData.subject : null;
    const solution = isData ? questionData.solution : null;
    const solutionimg = isData ? questionData.solutionimg : null;
    const video = isData ? questionData.video : null;
    let answer = "";

    if (ans === "option1") { answer = isData ? questionData.option1 : null; }
    else if (ans === "option2") { answer = isData ? questionData.option2 : null; }
    else if (ans === "option3") { answer = isData ? questionData.option3 : null; }
    else if (ans === "option4") { answer = isData ? questionData.option4 : null; }




    const [formData, setFormData] = useState({
        questionId: id,
        type: type,
        subject: subject,
        topic: "-",
        year: "-",
        message: ''
    });

    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submissionStatus, setSubmissionStatus] = useState(null);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
        setSubmissionStatus(null);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setSubmissionStatus(null);

        try {
            const response = await fetch(USERDOUBTSEND, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
            });

            if (!response.ok) {
                const errorData = await response.json().catch(() => ({ message: 'Server error' }));
                throw new Error(`Submission failed with status ${response.status}: ${errorData.message || 'Unknown error'}`);
            }
            setSubmissionStatus('success');
        } catch (error) {
            console.error('Contact form submission error:', error.message);
            setSubmissionStatus('error');
        } finally {
            setIsSubmitting(false);
        }
    };





    const renderWithLatex = (text) => {
        if (!text) return null;

        // Check if text contains LaTeX patterns
        if (text.includes('$') || text.includes('\\')) {
            return <Latex>{text}</Latex>;
        }
        return text;
    };


    return (
        <div className="contact-support-page">

            <TopNavbar name="Submit the report" />

            <br></br><br></br><br></br>

            <div className="contact-form-section">

                <p>We are sorry if you found any mistake. Please submit the report for the question and answer below. Our team will review it and resolve it as soon as possible.</p>


                <form onSubmit={handleSubmit} className="contact-form">



                    <div className="mistake-question-details">
                        {question_img ? (
                            <>
                                <div className="question-image-containerr">
                                    <img
                                        src={`/questionsPhoto/${question_img}`}
                                        alt="Question"
                                        className="question-photo"
                                    />
                                </div>
                            </>
                        ) : (
                            <>
                                <div className='question-text'>
                                    <h4>Q: {renderWithLatex(question)}</h4>
                                </div>
                            </>
                        )}
                    </div>

                    <div className="mistake-answer-details">
                        <p>Answer:  {renderWithLatex(answer)}</p>
                    </div>

                    <div className="form-group">

                        <textarea
                            id="message"
                            name="message"
                            rows="2"
                            value={formData.message}
                            onChange={handleInputChange}
                            placeholder="Tell us more about the issue..."
                            required
                        ></textarea>
                    </div>

                  {/*    {phoneFromStorage ? (<>   */}

                        {submissionStatus !== 'success' && (

                            <button
                                type="submit"
                                className="submit-btn"
                                disabled={isSubmitting} // Disable button while submitting
                            >
                                {isSubmitting ? 'Sending Report...' : 'Send Report'}
                            </button>

                        )}

                   {/*  
                    </>) : (<>

                        <Link to="/signup" className="signup-link submit-btn">Create account before submit report</Link>


                    </>)}
                    */}


                    {submissionStatus === 'success' && (
                        <p style={{ color: 'green', fontWeight: 'bold' }}>✅ Thank you! Your report has been sent. Our team will review it and resolve it as soon as possible.</p>
                    )}


                </form>

                <br></br> <br></br> <br></br> <br></br> <br></br>

            </div>


        </div>



    );
};

export default ReportSend;